const FolderIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.5938 9.1875V7.64062C28.5938 6.04687 27.3281 4.78125 25.7344 4.78125H15.3281L15.1875 4.40625C14.8594 3.5625 14.0625 3.04688 13.1719 3.04688H3.70313C2.10938 3.04688 0.84375 4.3125 0.84375 5.90625V24.1406C0.84375 25.7344 2.10938 27 3.70313 27H26.3438C27.9375 27 29.2031 25.7344 29.2031 24.1406V10.6406C29.2031 10.0781 28.9688 9.5625 28.5938 9.1875ZM25.7344 6.84375C26.1563 6.84375 26.4844 7.17188 26.4844 7.59375V8.48438H16.8281L16.1719 6.84375H25.7344ZM27.0938 24.1406C27.0938 24.5625 26.7656 24.8906 26.3438 24.8906H3.70313C3.28125 24.8906 2.95312 24.5625 2.95312 24.1406V5.85937C2.95312 5.4375 3.28125 5.10937 3.70313 5.10937L13.2188 5.15625L15.1406 9.9375C15.2812 10.3594 15.7031 10.5937 16.125 10.5937H27.0469C27.0469 10.5937 27.0938 10.5938 27.0938 10.6406V24.1406Z"
        fill="#BA0C2F"
      />
    </svg>
  );
};

export default FolderIcon;
